export default __webpack_public_path__ + "static/media/section2-bg1.04d2aa58.png";